import { Injectable } from '@angular/core';

import { ComponentStore } from '@ngrx/component-store';
import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import { TruckSearchResult, TruckSearchTable, CarriersProjectsList } from 'cargo-chief-commons';

import { State } from '@state/core.state';

import { ProjectDetailsState, initialState } from '../state';
import {
	numberOfLanes,
	loadingLanesList,
	capacitySearchResults,
	truckSearchResult,
	userCarrierMapList,
	recommendedCarriersProjectsList,
	userCarrierMap,
	recommendedCarriersProjectMap,
	truckLaneSearchId,
	capacitySearchCsvDownloadInProgress,
	bestMatch,
	filters,
	customerOnlyProject,
	hasLane,
} from '../selectors/recommended-carriers-selectors';

@Injectable({ providedIn: 'root' })
export class RecommendedCarriersStore extends ComponentStore<ProjectDetailsState> {
	public readonly numberOfLanes$: Observable<number> = this.store.pipe(select(numberOfLanes));

	public readonly loadingLanesList$: Observable<boolean> = this.store.pipe(
		select(loadingLanesList)
	);

	public readonly capacitySearchResults$: Observable<TruckSearchTable[]> = this.store.pipe(
		select(capacitySearchResults)
	);
	public readonly truckSearchResult$: Observable<TruckSearchResult[]> = this.store.pipe(
		select(truckSearchResult)
	);
	public readonly userCarrierMapList$: Observable<any> = this.store.pipe(
		select(userCarrierMapList)
	);
	public readonly recommendedCarriersProjectsList$: Observable<CarriersProjectsList[]> =
		this.store.pipe(select(recommendedCarriersProjectsList));

	public readonly userCarrierMap$: Observable<any> = this.store.pipe(select(userCarrierMap));
	public readonly recommendedCarriersProjectMap$: Observable<any> = this.store.pipe(
		select(recommendedCarriersProjectMap)
	);

	public readonly truckLaneSearchId$: Observable<string> = this.store.pipe(
		select(truckLaneSearchId)
	);

	public readonly capacitySearchCsvDownloadInProgress$: Observable<boolean> = this.store.pipe(
		select(capacitySearchCsvDownloadInProgress)
	);

	public readonly bestMatch$: Observable<number> = this.store.pipe(select(bestMatch));
	public readonly filters$: Observable<any> = this.store.pipe(select(filters));
	public readonly customerOnlyProject$: Observable<any> = this.store.pipe(
		select(customerOnlyProject)
	);
	public readonly hasLane$: Observable<boolean> = this.store.pipe(select(hasLane));

	constructor(private readonly store: Store<State>) {
		super(initialState);
	}
}
